import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    VStack,
} from '@chakra-ui/react';
import { Field } from 'formik';
// import walkthroughIds from '../../../walkthroughIds';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import TextAreaField from '@/components/forms/new/formikFormFields/TextAreaField';

const OperatorPlatformDescLong = ({ darkMode, errors, touched, ...props }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.descriptionLong && touched.descriptionLong}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                align="flex-start"
                sx={{
                    ...stackStyling(),
                    height: 'auto',
                    paddingTop: '10px',
                    paddingBottom: '10px',
                }}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Description (Long)
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Enter a detailed description.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <VStack width="100%" alignItems="normal">
                        <Field
                            component={TextAreaField}
                            id="descriptionLong"
                            name="descriptionLong"
                            placeholder="Enter detailed description"
                            width="100%"
                            // walkthroughid={
                            //     walkthroughIds.serviceProfiles?.ufDescLong
                            // }
                            rows={3}
                            error={errors.descriptionLong}
                            {...props}
                        />
                    </VStack>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Enter a detailed description."
                        ariaLabel="operator-platform-descriptionLong-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default OperatorPlatformDescLong;
